import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import {
  assignmentRequestRequest,
  assignmentRequestSuccess,
  assignmentRequestFailure,
} from '../reducers/assignmentRequest';
import { API_LINK } from '../../constants';
import {getUserProgramsFullRequest, setApproved} from '../reducers/userProgramsFull'; 
import {assignmentRequest} from '../reducers/assignmentRequest';
import { contentItemRequest } from '../reducers/contentList';
import { modulesListRequest } from '../reducers/modulesList';


const API = `${API_LINK}`;

function* assignmentRequestAxios() {
  const state = yield select(fullState => fullState);
  const {
    user: { userId },
    token,
  } = state.loginReducer;
  const { selectedContentId: contentId, selectedAssessmentId, selectedProgramId, selectedModuleId, selectedRolloutId, approved, assessmentContent, cost, reference } = state.userProgramsFullReducer;
  const { assignmentRequestType, comment, file, file_count, media_type } = state.assignmentRequest;
  const user_id = userId
  const survey_id = selectedAssessmentId
  const rollout_id = selectedRolloutId
  const program_id = selectedProgramId
  const module_id = selectedModuleId

  const requestType = assignmentRequestType;
  
  var formData = new FormData();
  formData.append('file', file);
  formData.append('user_id', user_id)
  formData.append('survey_id', survey_id)
  formData.append('program_id', program_id)
  formData.append('rollout_id', rollout_id)
  formData.append('module_id', module_id)
  formData.append('requestType', requestType)
  formData.append('approved', approved)
  formData.append('cost', cost)
  formData.append('file_count', file_count)
  formData.append('comment', comment)
  formData.append('media_type', media_type)
  formData.append('transactionNo', reference)
  const response = yield call(() =>
    axios({
      method: 'post',
      url: `${API}api/surveyRequest`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      },
      formData,
      data: formData,
    }),
  );
  
  return response;
}

function* assignmentRequestSaga() {
  try {
    
    const response = yield call(assignmentRequestAxios);
    yield put(assignmentRequestSuccess(response.data));
    yield put(contentItemRequest())
    yield put(setApproved(0))
  } catch (error) {
    
    yield put(assignmentRequestFailure(error));
  }
}

export function* watcherAssignmentRequestSaga() {
  
  yield takeLatest(assignmentRequestRequest().type, assignmentRequestSaga);
}
